// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"jb","landingPageVideo":"kb","play":"lb","iframeVideo":"mb","playHidden":"nb","playVisible":"ob","fullwidth":"pb"};